import React, { useState, useLayoutEffect, useRef, useEffect, } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { setOpenMainPage } from "../../../actions";
import { usePagesContext, useWindowContext } from "../../../contexts";
import { joinClasses } from "../../../ui/utils/joinClasses";
import { getIconPath } from "../iconMap";
import { useSpineContext } from "../Spine/SpineContext";
import { DownloadsMenuContent } from "./DownloadsMenuContent";
import { MenuButton } from "./MenuButton";
import { ToolsProvider, useToolsContext } from "./ToolsContext";
import { ToolsSection } from "./ToolsSection";
const toolPadding = {
    1: "pb-28",
    2: "pb-37.5",
    3: "pb-47",
    4: "pb-56.5",
    5: "pb-66",
};
const MenuContent = () => {
    const { t } = useTranslation();
    const { menuIsCollapsed } = useWindowContext();
    const { selection, visiblePages } = useSpineContext();
    const dispatch = useDispatch();
    const scrollRef = useRef(null);
    const { mainPage } = usePagesContext();
    const { visibleTools } = useToolsContext();
    const toolCount = visibleTools.length;
    const [canScrollUp, setCanScrollUp] = useState(false);
    const [isAnimating, setIsAnimating] = useState(false);
    const onScroll = (event) => setCanScrollUp(event.target.scrollTop > 0);
    useEffect(() => {
        if (!scrollRef.current) {
            return;
        }
        const element = scrollRef.current;
        element.addEventListener("scroll", onScroll);
        return () => element.removeEventListener("scroll", onScroll);
    }, [scrollRef]);
    useLayoutEffect(() => {
        // eslint-disable-next-line @eslint-react/hooks-extra/no-direct-set-state-in-use-effect
        setIsAnimating(true);
        const timer = setTimeout(() => setIsAnimating(false), 150);
        return () => clearTimeout(timer);
    }, [menuIsCollapsed]);
    return (React.createElement("div", { className: joinClasses([
            "relative -mt-1 flex shrink-0 flex-col pr-0.5 transition-[width]",
            menuIsCollapsed ? "w-16" : "w-56",
        ]) },
        canScrollUp && (React.createElement("div", { className: "pointer-events-none absolute inset-x-0 top-0 z-1 h-6 bg-linear-to-b from-surface-base to-transparent" })),
        React.createElement("div", { className: "mr-1 min-h-0 w-full overflow-y-auto pl-3", ref: scrollRef },
            React.createElement("div", { className: joinClasses([
                    "flex flex-col gap-y-0.5 pt-1 transition-[width]",
                    menuIsCollapsed ? `w-10 ${toolPadding[toolCount]}` : "w-50 pb-28",
                ]) }, selection.type === "downloads" ? (React.createElement(DownloadsMenuContent, null)) : (visiblePages.map((page) => (React.createElement(MenuButton, { iconPath: page.mdi ?? getIconPath(page.icon), isActive: mainPage === page.id, key: page.id, onClick: () => {
                    if (mainPage === page.id) {
                        page.onReset?.();
                    }
                    else {
                        dispatch(setOpenMainPage(page.id, false));
                    }
                } }, t(page.title, { ns: page.namespace })))))),
            React.createElement("div", { className: "pointer-events-none absolute right-0 bottom-0 size-3 bg-surface-base" })),
        React.createElement(ToolsSection, { isAnimating: isAnimating }),
        React.createElement("div", { className: "pointer-events-none absolute inset-x-0 bottom-0 z-1 h-6 bg-linear-to-t from-surface-base to-transparent" })));
};
export const Menu = () => {
    return (React.createElement(ToolsProvider, null,
        React.createElement(MenuContent, null)));
};
